import { render } from "./CreditsHistory.vue?vue&type=template&id=4c1cfff8&scoped=true"
import script from "./CreditsHistory.vue?vue&type=script&lang=js"
export * from "./CreditsHistory.vue?vue&type=script&lang=js"

import "./CreditsHistory.vue?vue&type=style&index=0&id=4c1cfff8&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c1cfff8"]])

export default __exports__